import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";

import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { EventBodyTabs } from "@data-types/offer/event/EventViewStoreEnums";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";

import { EventContentToggleButton } from ".";

export default observer(function MarketsToggleButton(props: {
	store: EventViewStore | AdditionalOfferViewStore;
}) {
	const { t } = useTranslation();

	return (
		<EventContentToggleButton
			title={t("EVENT.HEADER.MARKETS")}
			isActive={props.store.currentTab === EventBodyTabs.Markets}
			onClick={() => props.store.openTab(EventBodyTabs.Markets)}
		/>
	);
});
